import BreadCrumbs from 'components/breadcrumbs'
import DetailPage from './DetailPage'
import { URL_UTANG } from 'utils/pathUrl'

const DetailPayable = () => {
  return (
    <>
      <div className="w-100 px-3">
        <div className="d-flex align-items-start gap-2 pt-3">
          <BreadCrumbs
            breadCrumbParent={'Utang'}
            breadCrumbParentLink={URL_UTANG}
            breadCrumbActive={'Detail Utang'}
          />
        </div>
        <DetailPage />
      </div>
    </>
  )
}

export default DetailPayable
